import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import LogoutPage from './components/LogoutPage';
import ProfilePage from './components/ProfilePage';
import GoogleReviewQrCodeConfigPage from './components/GoogleReviewQrCodeConfigPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import AddQrCodePage from './components/AddQrCodePage';
import ReviewInsight from './components/ReviewInsight';
import { AlertProvider } from './components/shared/CustomAlert';
import { SMART_PROFILES_ENABLED } from './smart/model';
import ScanRouter from './smart/ScanRouter';
const ProfileBuilder = lazy(() => import('./smart/ProfileBuilder'));
const PublicProfile = lazy(() => import('./smart/PublicProfile'));
const ProductDashboard = lazy(() => import('./smart/ProductDashboard'));
const InquiryInbox = lazy(() => import('./smart/InquiryInbox'));

function App() {
  return (
    <AlertProvider>
      <Router>
        <Suspense fallback={<p role="status">Loading page…</p>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/add-qr-code" element={<AddQrCodePage/>}/>
          <Route path="/google-review-config" element={<GoogleReviewQrCodeConfigPage />} />
          <Route path="/r" element={<ScanRouter />} />
          {SMART_PROFILES_ENABLED && <>
            <Route path="/studio" element={<ProductDashboard />} />
            <Route path="/studio/activate" element={<ProductDashboard activate />} />
            <Route path="/studio/inbox" element={<InquiryInbox />} />
            <Route path="/studio/:id" element={<ProfileBuilder />} />
            <Route path="/p/:id" element={<PublicProfile scanned />} />
          </>}
          <Route path="/review-insight/:qrCodeId" element={<ReviewInsight />} />
        </Routes>
        </Suspense>
      </Router>
    </AlertProvider>
  );
}

export default App;
